/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import objectPath from "object-path";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from "../../_core/MetronicSubheader";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { SearchDropdown } from "../extras/dropdowns/search/SearchDropdown";
import { BreadCrumbs } from "./components/BreadCrumbs";
export function SubHeader() {
  const { t } = useTranslation();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const history = useHistory();
  const role = JSON.parse(localStorage.getItem("user")).roles[0];
  const { token } = JSON.parse(localStorage.getItem("user"));
  const [isCostsMissing, setisCostsMissing] = useState(false);
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();
  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderFixed: objectPath.get(uiService.config, "subheader.fixed"),
      subheaderMobileToggle: objectPath.get(
        uiService.config,
        "subheader.mobile-toggle"
      ),
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses(
        "subheader_container",
        true
      ),
    };
  }, [uiService]);

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    const breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
    subheader.setBreadcrumbs(breadcrumbs);
    subheader.setTitle(
      aside && aside.title && aside.title.length > 0
        ? aside.title
        : header.title
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  const handleMenu = () => {
    fetch(BASE_URL + "/Generic/Menu", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      Allow: "GET",
    })
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          setisCostsMissing(data[1]?.isCostsMissing);
        }
        else if (data[0] === 401) {
          history.push("/logout");
        }
        else if (data[0] === 450) {
          history.push("/setup/twoFactor");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    handleMenu();
  }, []);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => {}, [subheader]);

  return (
    <div
      id="kt_subheader"
      className={`subheader py-3 py-lg-8 ${layoutProps.subheaderCssClasses} ${window.location.pathname === "/command-center" ? "d-none" : ""}`}
    >
      <div
        className={`${layoutProps.subheaderContainerCssClasses} d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap`}
      >
        {/* Info */}
        <div className="d-flex align-items-center flex-wrap mr-1">
          {/* begin::Mobile Toggle */}
          {layoutProps.subheaderMobileToggle && (
            <button
              className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
              id="kt_subheader_mobile_toggle"
            >
              <span />
            </button>
          )}
          {/* end::Mobile Toggle */}

          {/* begin::Heading */}
          <div className="d-flex align-items-baseline mr-5">
            {/* begin::Title */}
            <h2 className="subheader-title text-dark font-weight-bold my-2 mr-3">
              {subheader.title}
            </h2>
            {/* end::Title */}

            <BreadCrumbs items={subheader.breadcrumbs} />
          </div>
          {/* end::Heading */}
        </div>
        {/* Info */}

        {/* Toolbar */}
        {role === "Carrier Admin" && isCostsMissing === true && (
          <div
            className="alert alert-custom alert-notice alert-light-warning fade show py-1 mb-0"
            role="alert"
          >
            <div className="alert-icon">
              <i className="flaticon-warning font-size-sm" />
            </div>
            <div className="alert-text">
              {t("You have to setup your costs, Settings")} <span>{">"}</span>{" "}
              <a href="/settings-carriers" className="ml-1 text-info">
                Pricing
              </a>
            </div>
          </div>
        )}

        <div className="d-flex align-items-center flex-wrap">
          <SearchDropdown />
          <LanguageSelectorDropdown />
        </div>
      </div>
    </div>
  );
}
